<div class="logbook-search-section">
  <article  class="logbook-search-main">
    <app-helpers-search-bar-main
      [placeholder]="'Search the logbook'"
      [term]="term"
      [filters]="appliedFilters"
      (termChanges)="onSetTerm($event)"
      (removeFilter)="onRemove($event)"
    ></app-helpers-search-bar-main>

    <projects-logbook-search-filters></projects-logbook-search-filters>
  </article>
</div >

